import { render, staticRenderFns } from "./AmapComponent.vue?vue&type=template&id=7070c4c8&scoped=true"
import script from "./AmapComponent.vue?vue&type=script&lang=js"
export * from "./AmapComponent.vue?vue&type=script&lang=js"
import style0 from "./AmapComponent.vue?vue&type=style&index=0&id=7070c4c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7070c4c8",
  null
  
)

export default component.exports